var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-2 w-full"},[_c('Breadcrumb',{staticClass:"w-full",attrs:{"home":"/","menu":[{ title: _vm.$t('shared.home'), routePath: '/' },
    { title: _vm.$t('admin.components.title'), routePath: _vm.currentRoute },
    { title: 'Breadcrumbs' }]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }